<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2 v-if="this.id">Edit</h2> 
                <h2 v-else>Create</h2>
                <h4>Force</h4>
            </div>
        </div> 
        <div class="row mt-4">
            <form novalidate="novalidate" @submit.prevent="submit"  class="col col-md-12 border-top border-bottom py-4"> 
                <!--  needs-validation -->
                <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">Name</label> 
                    <div class="col-sm-6">
                        <input type="text" id="name" required="required" autofocus="autofocus" class="form-control"  
                            :class="{'is-invalid': hasNameError}"
                            v-model="name"
                            :disabled="this.loading" > 
                        <form-error name="name" :errors="errors"></form-error>
                    </div>
                </div> 
                <div class="form-group row">
                    <label for="forceImage" class="col-sm-2 col-form-label">Header Image</label>
                    <div class=" col-sm-10">
                        <div id="force_image_thumb" v-if="header_image_url">
                            <img id="new_force_image" :src="header_image_url" style="max-height:96px; border: solid black 1px" class="mb-2 border-primary">
                        </div>
                        <div class="input-group" :class="{'is-invalid': hasImageError}">
                            <input type="file" class="custom-file-input image-uploader" id="forceImage" name="header_image" accept="image/jpg"
                                :class="{'is-invalid': hasImageError}"
                                :disabled="this.loading" 
                                ref="headerImageFile" 
                                @change="uploadImage">
                            <label class="custom-file-label" for="forceImage">Choose file</label>
                        </div>
                        <form-error name="header_image" :errors="errors"></form-error>
                        <small id="emailHelp" class="form-text text-muted">For best results, image size should be 611 x 96 pixels. Must be in jpg format. <strong>Max file size 4MB</strong></small>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-10 offset-sm-2" v-if="this.id">
                        <button type="submit" class="btn btn-primary" v-if="! this.loading">Edit</button>
                        <button type="submit"  class="btn btn-primary" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                    <div v-else>
                        <button type="submit" class="btn btn-primary" >Create</button>
                    </div>
                </div> 
                <router-link :to="{name:'forces.index'}">Back to List</router-link>
            </form>
        </div>
    </div>
</template>

<script>
import FormError from "../../Util/FormError"
import ForcesService from "../../../services/ForcesService"

export default {
    data: function () {
        return {
            loading: false,
            name: '',
            header_image_file: '',
            header_image_url: '',
            errors: {},
        }
    },

    props: {
        id: {
            default: null,
        },
    },
    
    components: {FormError},

    mounted(){
        if (this.id) {
            this.load();
        }
    },

    watch: {
        id: function () {
            this.load();  
        },
    },

    methods: {
        submit: function () {
            if (this.id === null) {
                ForcesService.store(this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            } else {
                ForcesService.update(this.id, this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            }
        },

        formData: function () {
            let formData = new FormData();

            formData.append('name', this.name);
            
            if (this.header_image_file) {
                formData.append('header_image', this.header_image_file);
            }

            return formData;
        },

        uploadImage: function () {
            this.header_image_file = this.$refs.headerImageFile.files[0];
        },

        success: function () {            
            window.flash((this.id ? 'Force Updated' : 'Force Created'));
            this.reset();
            this.$router.push({name: 'forces.index'});
        },

        failed: function (response) {
            this.errors = response.data.errors;
        },

        load: function () {
            this.loading = true;
            ForcesService.get(this.id)
                .then( ({data}) => {
                    this.name = data.data.name;
                    this.header_image_url = data.data.header_image_url;
                    this.loading = false;
                });
        },

        reset: function () {
            this.name = this.header_image_file = this.header_image_url = '';
            this.errors = {};
        }
    },

    computed: {
        hasNameError: function () { return (this.errors['name']); },
        hasImageError: function () { return (this.errors['header_image']); }
    }
}
</script>